import { event, zoom } from "d3";
import { Bar } from "./figuresZoomY/Bar";
import { Text } from "./figuresZoomY/Text";
import { Scatter } from "./figuresZoomY/Scatter";
import { Line } from "./figuresZoomY/Line";

export class ChartZoomY {
  constructor({
    _this,
    svg,
    figuresElements = [{}],
    data = [],
    render = "",
    heightResizeZoom = false,
    svgAux = null,
    isZoomSync = false
  }) {
    this.svg = svg;
    this.svgAux = svgAux || svg;
    this._this = _this;
    this.yInit = this.svg.y.copy();
    this.isResizeZoomDblClck = false;
    this.isDblClick = false;
    this.figuresElements = figuresElements;
    this.data = data;
    this.reRender = render;
    this.heightResizeZoom = heightResizeZoom;
    this.isZoomSync = isZoomSync;

    if (this.isZoomSync) {
      ZoomManager.addInstance(this);
    }
  }

  destroy() {
    if (this.isZoomSync) {
      ZoomManager.removeInstance(this);
    }
  }

  applyTransform(transform) {
    this.svg.y.domain(transform.rescaleY(this.yInit).domain());
    this.svg.gY.call(this.svg.yAxis.scale(transform.rescaleY(this.svg.y)));
    this.svg.y = transform.rescaleY(this.svg.y);

    this.svg.gYRect.style("cursor", "ns-resize");
    this.svg.gY.transition().call(this.svg.yAxis.scale(this.svg.y));

    this.figuresZoomY();
  }

  zoomedY() {
    const transform = event.transform;
    this.applyTransform(transform);

    if (this.isZoomSync) {
      ZoomManager.synchronizeZoom(this, transform);
    }
  }

  figuresZoomY() {
    this.figuresElements.forEach(figure => {
      const instanceBar = new Bar(this.svg, this.svgAux);

      switch (figure.type) {
        case "bars": {
          instanceBar.barsGroup(this._this, figure.data, this);
          break;
        }
        case "barsOld": {
          instanceBar.barsGroupOld(this._this, figure.data, this);
          break;
        }
        case "candlesOld": {
          instanceBar.candlesOld(this._this, figure.data, this);
          break;
        }
        case "texts": {
          let obj = new Text(this.svg, this.svgAux);
          obj.textsZoom(this._this, figure.data);
          break;
        }
        case "twoScatters": {
          const scatter = new Scatter(this.svg, this.svgAux);
          scatter.scattersZoom(this._this, figure.data);
          break;
        }
        case "twoScattersOld": {
          const scatter = new Scatter(this.svg, this.svgAux);
          scatter.scattersOld(this._this, figure.data);
          break;
        }
        case "scatterBarriersOld": {
          const scatter = new Scatter(this.svg, this.svgAux);
          scatter.scatterBarriers(this._this, figure.data, true);
          break;
        }
        case "scatterBarriers": {
          const scatter = new Scatter(this.svg, this.svgAux);
          scatter.scatterBarriers(this._this, figure.data);
          break;
        }
        case "multipleStackedBars": {
          instanceBar.multipleStackedBarsZoom(this._this, figure.data, this);
          break;
        }
        case "customLine": {
          const instanceLine = new Line(this.svg, this.svgAux);
          if (this._this.lineData) {
            this._this.lineData.forEach(line => {
              if (line.type === "customLine") {
                instanceLine.customLine(line);
              }
            });
          }
          break;
        }
      }
    });
  }

  getTypeEventZoomY() {
    const zoomY = zoom().on("zoom", () => {
      if (!this.isResizeZoomDblClck) this.zoomedY();
      if (event.sourceEvent === null) {
        this.isDblClick = true;
      }
      if (!this.isDblClick) this.zoomedY();
      if (this.isDblClick) {
        Object.assign(this.data, {
          render: !this.data[this.reRender]
        });
        this.zoomedY();
        this.isDblClick = false;
      }
    });

    this.svg.gYRect.call(zoomY);
  }
}

class ZoomManager {
  static instances = [];

  static addInstance(instance) {
    if (instance.isZoomSync) {
      // Validate if an instance already exists for the same SVG
      const existingInstanceIndex = this.instances.findIndex(
        inst => inst.svg.parentElement === instance.svg.parentElement
      );

      // If a previous instance exists, remove it
      if (existingInstanceIndex !== -1) {
        this.instances.splice(existingInstanceIndex, 1);
      }

      // Add the new instance
      this.instances.push(instance);
    }
  }

  static removeInstance(instance) {
    const index = this.instances.findIndex(
      inst => inst.svg.parentElement === instance.svg.parentElement
    );
    if (index !== -1) {
      this.instances.splice(index, 1);
    }
  }

  static synchronizeZoom(sourceInstance, transform) {
    if (sourceInstance.isZoomSync) {
      this.instances.forEach(instance => {
        if (instance !== sourceInstance && instance.isZoomSync) {
          instance.applyTransform(transform);
        }
      });
    }
  }
}
